export const preloaderActionTypes = {
    
   PRELOADER_ADD_FILES: 'PRELOADER_ADD_FILES',
   PRELOADER_FILE_LOADED: 'PRELOADER_FILE_LOADED',
   PRELOADER_CLEAR_FILES: 'PRELOADER_CLEAR_FILES'

};


// WEBPACK FOOTER //
// ./src/preloader/actions/preloader-action-types.js